import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import AssessmentSlide from "./AssessmentSlide";
import AssessmentResult from "./AssessmentResult";
import "../css/LearnerAssessment.css";

const LearnerAssessment = () => {
  const {
    startAssessment,
    submitAssessment,
  } = useAuth();

  const [attemptId, setAttemptId] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [violations, setViolations] = useState(0);

  /* ================= START ASSESSMENT ================= */
  useEffect(() => {
    const initAssessment = async () => {
      try {
        const start = await startAssessment();
        console.log("Start Assessment:", start);
        setAttemptId(start.attempt_id);
        setQuestions(start.questions);

        enterFullscreen();
      } catch (err) {
        console.error("Assessment error:", err);
      }
    };
    initAssessment();
  }, [startAssessment]);

  /* ================= FULLSCREEN LOCK ================= */
  const enterFullscreen = () => {
    const elem = document.documentElement;
    if (elem.requestFullscreen) elem.requestFullscreen();
  };

  /* ================= TAB SWITCH DETECTION ================= */
  useEffect(() => {
    const handleVisibility = () => {
      if (document.hidden) {
        setViolations((v) => v + 1);
      }
    };

    document.addEventListener("visibilitychange", handleVisibility);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibility);
  }, []);

  /* ================= ANSWER CHANGE ================= */
  const handleAnswer = (questionId, value) => {
    setAnswers((prev) => ({
      ...prev,
      [questionId]: value,
    }));
  };

  /* ================= NEXT SLIDE ================= */
  const nextSlide = () => {
    if ((currentSlide + 1) * 2 >= questions.length) {
      handleSubmit();
    } else {
      setCurrentSlide(currentSlide + 1);
    }
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async () => {
    try {
      console.log("Submitting assessment...");
      console.log("Attempt ID:", attemptId);
      console.log("Answers:", answers);
      const response = await submitAssessment(attemptId, answers);
      if (document.fullscreenElement) document.exitFullscreen();
      setSubmitted(response);
    } catch (error) {
      console.error("Submission error:", error);
    }
  };

  if (submitted) return <AssessmentResult result={submitted} />;

  if (!questions || questions.length === 0) {
    return <div>Loading questions...</div>;
  };

  const slideQuestions = questions.slice(
    currentSlide * 2,
    currentSlide * 2 + 2
  );

  return (
    <div className="assessment-container">
      <h2>Assessment</h2>

      <AssessmentSlide
        questions={slideQuestions}
        answers={answers}
        onAnswer={handleAnswer}
      />

      <div className="assessment-nav">
        <button className="btn" onClick={nextSlide}>
          {((currentSlide + 1) * 2 >= questions.length)
            ? "Submit"
            : "Next"}
        </button>
      </div>

      <p className="warning">
        Do not leave fullscreen or switch tabs. Violations: {violations}
      </p>
    </div>
  );
};

export default LearnerAssessment;